import React from "react";

interface NoDataPlaceholderProps {
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onMouseEnter?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function NoDataPlaceholder({ onClick, onMouseEnter }: NoDataPlaceholderProps) {
  return (
    <div
      className="qr-alt"
      style={{ width: "100%", maxWidth: "300px", height: "100%", position: "relative" }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: "100%",
          background: `url("/img/img_empty.png") center/contain no-repeat`,
          opacity: 0.25,
          transition: "opacity 0.3s ease-in-out",
          cursor: "help",
          border: "2px solid #c5c9cc",
          borderRadius: "8px",
          backgroundColor: "#c5c9cc",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = "1"; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = "0.25"; }}
      />
    </div>
  );
}

export default NoDataPlaceholder;

